import React from 'react';

import { Flex } from 'components/styled';
import Text from 'components/styled/Text';

import {
	CompanySizeTextPrimary,
	CompanySizeTextSecondary,
	OwnershipSectorName,
} from 'utils/enumMaps';

import { ReactComponent as BusinessSectorIcon } from './assets/businessSectorIcon.svg';
import { ReactComponent as SectorIcon } from './assets/sectorIcon.svg';
import { ReactComponent as SizeIcon } from './assets/sizeIcon.svg';
import { ReactComponent as FoundedIcon } from './assets/foundedIcon.svg';

import { Company } from 'typing/endpoints';

type BasicInfoItemProps = {
	icon: React.FC<React.SVGProps<SVGSVGElement>>;
	title: string;
	text: string;
	secondaryText?: string;
};
const BasicInfoItem: React.FC<BasicInfoItemProps> = ({
	icon: Icon,
	title,
	text,
	secondaryText,
}) => (
	<Flex
		flexDirection="column"
		alignItems="center"
		flexBasis={['100%', '50%', '25%']}
		mt={[3, 2]}
		color="primary"
	>
		<Icon />

		<Text mb={0} color="text">
			{title}
		</Text>

		<Text
			mt={0}
			mb={secondaryText ? 0 : 2}
			fontSize="lg"
			fontWeight="bold"
			textAlign="center"
		>
			{text}
		</Text>

		{secondaryText && (
			<Text mt={0} color="textLight">
				{secondaryText}
			</Text>
		)}
	</Flex>
);

const CompanyBasicInfo: React.FC<Pick<
	Company,
	'size' | 'formationYear' | 'ownershipSector' | 'businessSector'
>> = ({ size, formationYear, ownershipSector, businessSector }) => (
	<Flex
		justifyContent="space-around"
		flexWrap="wrap"
		flexDirection={['column', 'row']}
	>
		{ownershipSector && (
			<BasicInfoItem
				icon={SectorIcon}
				title="Sektor"
				text={OwnershipSectorName[ownershipSector]}
			/>
		)}

		{businessSector && (
			<BasicInfoItem
				icon={BusinessSectorIcon}
				title="Odvětví"
				text={businessSector.name}
			/>
		)}

		{size && (
			<BasicInfoItem
				icon={SizeIcon}
				title="Velikost"
				text={CompanySizeTextSecondary[size]}
				secondaryText={CompanySizeTextPrimary[size]}
			/>
		)}

		{formationYear && (
			<BasicInfoItem
				icon={FoundedIcon}
				title="Rok založení"
				text={`${formationYear}`}
			/>
		)}
	</Flex>
);

export default CompanyBasicInfo;
